import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';

export default async function doSubscribeNewsletter(email: string) {
  try {
    await spiritoryWebApi.post('/newsletter', { email });
  } catch (err) {
    throw err;
  }
}
